var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview",class:{ 'preview--default': !_vm.text }},[_vm._v(" "+_vm._s(_vm.text || _vm.defaultText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }